<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb" />
    <div class="wrap max-width">
      <div class="title">{{ data ? data.title : '' }}</div>
      <div class="desc">
        <span>日期：{{ data.publishTm ? data.publishTm.slice(0, 10) : '' }}</span>
        <p style="margin: 0 10px">|</p>
        <span>来源：{{ data ? data.origin : '' }}</span>
        <!-- <p style="margin: 0 10px">|</p> -->
        <!-- <span>浏览次数：{{ 0 }}</span> -->
      </div>
      <!-- {{ data.cont }} -->
      <div class="cont" v-html="data.cont" />
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
export default {
  name: 'NewsDetail',
  components: { Breadcrumb },
  beforeRouteEnter(to, from, next) {
    console.log('to===', to.name)
    console.log('from.name ===', from.name)
    console.log('from ===', from)
    next((vm) => {
      if (from.name === '首页') {
        // 处理语句，可以是 data 中的数据，也可以是 methods中的函数。vm 相当于 this
        vm.breadcrumb = [
          {
            path: '/',
            name: '首页',
            meta: {
              title: '首页',
            },
          },
          {
            path: '/news-detail/:id',
            name: '资讯详情',
            meta: {
              title: '资讯详情',
            },
          },
        ]
      } else {
        vm.breadcrumb = [
          {
            path: '/',
            name: '首页',
            meta: {
              title: '首页',
            },
          },
          {
            path: '/hot-news',
            name: '资讯列表',
            meta: {
              title: '资讯列表',
            },
          },
          {
            path: '/news-detail/:id',
            name: '资讯详情',
            meta: {
              title: '资讯详情',
            },
          },
        ]
      }
    })
  },

  data() {
    return {
      data: {},
      breadcurmb: [],
    }
  },
  mounted() {
    this.getDetails()
  },
  methods: {
    getDetails() {
      this.$http({ method: 'get', url: '/zzmh/api/information/info/' + this.$route.params.id }).then(({ data: res }) => {
        console.log(res)
        this.data = res
        if (res.contUrl && res.urlStatus == 2) {
          // 如果是外链，直接打开
          window.open(res.contUrl, '_self')
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .wrap {
    color: #000;
    background-color: white;
    margin-left: 8.3%;
    margin-right: 8.3%;
    padding-left: 60px;
    padding-right: 60px;
    .title {
      padding-top: 40px;
      padding-bottom: 20px;
      font-family: PingFangSC-Semibold;
      font-size: 24px;
      color: rgba(51, 51, 51, 0.85);
      text-align: center;
      line-height: 24px;
      font-weight: 600;
    }
    .desc {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-bottom: 50px;
      border-bottom: 2px solid #e6e6e7;
      span {
        color: rgba(0, 0, 0, 0.45);
      }
    }
    .cont {
      margin: 3.4722vw 0;
      white-space: pre-wrap;
      font-size: 16px;
      letter-spacing: 1px;
      line-height: 30px;
    }
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
